import React from 'react';
import PropTypes from 'prop-types';
import AccountManageMenu from 'components/nav/authenticated/mobile/AccountManageMenu';
import LanguageMenu from 'components/nav/shared/LanguageMenu';
import MobileMenuForward from 'components/nav/shared/MobileMenuForward';
import NavLink from 'components/nav/shared/NavLink';
import PrimaryItems from 'components/nav/authenticated/PrimaryItems';
import UtilityItems from 'components/nav/authenticated/UtilityItems';
import Locale from 'utils/Locale';

class MainMenu extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    transitionToMenu: PropTypes.func.isRequired,
  };

  static menuName = 'main';

  constructor(props) {
    super(props);
    this.handleManageAccountClick = this.handleManageAccountClick.bind(this);
    this.handleLanguageClick = this.handleLanguageClick.bind(this);
  }

  handleManageAccountClick() {
    this.props.transitionToMenu(AccountManageMenu.menuName);
  }

  handleLanguageClick() {
    this.props.transitionToMenu(LanguageMenu.menuName);
  }

  render() {
    const localeStringID = Locale.buildLocaleStringId(this.props.currentLocale);
    return (
      <div>
        <PrimaryItems transitionToMenu={this.props.transitionToMenu} />
        <UtilityItems />
        <ul className="nav navbar-nav">
          <MobileMenuForward callback={this.handleManageAccountClick} stringID="AA_Manage_Account" />
          <li className="row">
            <div className="col-xs-6 aa-nav-item-divider">
              <NavLink to="/signout" stringID="AA_SignOut" shouldRefresh />
            </div>
            <div className="col-xs-6">
              <MobileMenuForward callback={this.handleLanguageClick} stringID={localeStringID} />
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default MainMenu;
